export type IJurisdictionFormDocumentTypeRelation = {
  jurisdictionFormId: number;
  documentTypeId: number;
};

export const JurisdictionFormDocumentTypeDataUtil = {
  generateEntityKey: (args: Pick<IJurisdictionFormDocumentTypeRelation, "jurisdictionFormId" | "documentTypeId">) =>
    `jurisdictionFormId:${args.jurisdictionFormId}|documentTypeId:${args.documentTypeId}`,
};
